// This should cover extension-hosted scripts in Chromium (Chrome and Edge
// alike), Firefox, and Safari.
const EXTENSION_URL_PATTERN = /^(?:chrome|moz|safari(?:-web)?)-extension:\/\//

// This should cover fetch failures for Chromium, Firefox, and WebKit. All three
// are matched whole, so a message of ours that merely quotes one is unaffected.
const FETCH_FAILURE_PATTERN = /^(?:Failed to fetch|NetworkError when attempting to fetch resource\.?|Load failed)$/


// An extension that replaces `window.fetch` inserts its wrapper into every
// request the page makes, so when it blocks one (an analytics beacon, most often)
// the rejection surfaces through its frames. Those frames are what mark the
// failure as the extension's rather than ours; the message alone proves nothing,
// because a blocked beacon and a genuinely broken request of ours read
// identically. The origin check can't make the call either, because
// @sentry/browser and Datadog RUM wrap `fetch` too and their wrappers are served
// from our origin, leaving the event first-party on the strength of plumbing
// alone.
//
// The message and the extension frame can land in separate exception values when
// the rejection is chained onto another error, so each half is asked of the whole
// event rather than of one exception at a time.
//
export default function isExtensionFetchFailure({ frames, values }) {
  const isFetchFailure = values.some(({ value }) => FETCH_FAILURE_PATTERN.test(value || ''))
  const hasExtensionFrame = frames.some(({ filename }) => EXTENSION_URL_PATTERN.test(filename || ''))

  return isFetchFailure && hasExtensionFrame
}
